<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="activeStep" class="ui-module-stepper">
          <v-stepper-step step="1"> Información de evaluación de desempeño académico </v-stepper-step>
          <v-stepper-content step="1">
            <AcademicPerformanceEvaluationGeneralInfoForm
              :idPersonal="id"
              :evaluation="informacionGeneralAcademico"
              @save="(evaluations) => getLatestCreatedEvaluations(evaluations)"
            />
          </v-stepper-content>
          <v-stepper-step step="2"> Información de evaluación de desempeño académico </v-stepper-step>
          <v-stepper-content step="2">
            <v-container>
              <v-row>
                <v-col v-for="{ title, evaluation } in evaluations" :key="title">
                  <v-card class="ui-module-card ui-module-fade-in-up ui-evaluation-card" color="primary">
                    <v-card-title class="ui-evaluation-card-title">
                      {{ title }}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-caption">Estatus de evaluación</div>
                      <div class="text-body-1">
                        {{
                          evaluation.details && evaluation.details.statusLabel
                            ? evaluation.details.statusLabel
                            : 'No disponible'
                        }}
                      </div>
                    </v-card-text>
                    <v-card-actions class="ui-module-actions">
                      <v-btn class="mx-2 ui-module-btn-solid" @click="openEvaluationDialog(evaluation, title)"
                        >Evaluar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EvaluacionDesempenioInstitucionalDialogComponent from '../../components/desarrollo_policial/EvaluacionDesempenioInstitucionalDialogComponent.vue'
import AcademicPerformanceEvaluation from '../../modules/evaluacion-desempeño-academico/domain/entities/AcademicPerformanceEvaluation'
import { mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '../../plugins/dialog-types'
import AcademicPerformanceEvaluationGeneralInfoForm from '../../components/desarrollo_policial/evaluacion-desempeño-academico/forms/AcademicPerformanceEvaluationGeneralInfoForm.vue'
import RespetoValoresPrincipiosApiRepository from '@/modules/respeto-valores-principios/infrastructure/RespetoValoresPrincipiosApi.repository'
import GetRespetoValoresPrincipios from '@/modules/respeto-valores-principios/application/GetRespetoValoresPrincipios.usecase'
import RendimientoProfesionalismoApiRepository from '@/modules/rendimiento-profesionalismo/infrastructure/RendimientoProfesionalismoApi.repository'
import GetRendimientoProfesionalismo from '@/modules/rendimiento-profesionalismo/application/GetRendimientoProfesionalismo.usecase'
import DesempeñoInstitucionalApiRepository from '@/modules/desempeño-institucional/infrastructure/DesempeñoInstitucionalApi.repository'
import GetDesempeñoInstitucional from '@/modules/desempeño-institucional/application/GetDesempeñoInstitucional.usecase'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  components: {
    EvaluacionDesempenioInstitucionalDialogComponent,
    AcademicPerformanceEvaluationGeneralInfoForm,
  },

  data() {
    return {
      activeStep: 1,
      informacionGeneralAcademico: new AcademicPerformanceEvaluation(this.id),
      evaluations: [],
    }
  },

  methods: {
    ...mapActions('reactivoValor', ['fetchReactivoValor']),
    ...mapActions('reactivosEvaluacion', [
      'fetchReactivosDesempenioInstitucional',
      'fetchReactivosRendimientoProfesionalismo',
    ]),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('evaluacionesPersonal', ['SET_SELECTED_EVALUATION']),

    async getLatestCreatedEvaluations(evaluations) {
      try {
        const [respectForValuesAndPrinciples, performanceAndProfessionalism, institutionalPerformance] =
          await Promise.all([
            new GetRespetoValoresPrincipios(new RespetoValoresPrincipiosApiRepository()).execute({
              idPersonal: this.id,
              idEvaluacion: evaluations.respectForValuesAndPrinciplesEvaluationId,
            }),
            new GetRendimientoProfesionalismo(new RendimientoProfesionalismoApiRepository()).execute({
              idPersonal: this.id,
              idEvaluacion: evaluations.performanceAndProfessionalismEvaluationId,
            }),
            new GetDesempeñoInstitucional(new DesempeñoInstitucionalApiRepository()).execute({
              idPersonal: this.id,
              idEvaluacion: evaluations.institutionalPerformanceEvaluationId,
            }),
          ])

        if (respectForValuesAndPrinciples) {
          this.evaluations.push({
            title: 'Respeto a los principios y valores',
            evaluation: respectForValuesAndPrinciples,
          })
        }

        if (performanceAndProfessionalism) {
          this.evaluations.push({
            title: 'Rendimiento y profesionalismo',
            evaluation: performanceAndProfessionalism,
          })
        }

        if (institutionalPerformance) {
          this.evaluations.push({
            title: 'Desempeño institucional',
            evaluation: institutionalPerformance,
          })
        }

        this.activeStep = 2
      } catch {
        throw new Error('Error al obtener las evaluaciones de desempeño académico')
      }
    },

    async openEvaluationDialog(evaluation, title) {
      switch (title) {
        case 'Desempeño institucional':
          await this.fetchReactivosDesempenioInstitucional()
          break
        case 'Rendimiento y profesionalismo':
          await this.fetchReactivosRendimientoProfesionalismo()
          break
        case 'Respeto a los principios y valores':
          await this.fetchReactivoValor()
          break
      }

      this.SET_SELECTED_EVALUATION(evaluation)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_EVALUACION_DESEMPEÑO_ACADEMICO)
    },
  },
}
</script>

<style scoped>
.ui-evaluation-card {
  height: 100%;
}

.ui-evaluation-card-title {
  color: #e0e0e0 !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
}

::v-deep .ui-module-stepper {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .ui-module-stepper .v-stepper__header {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.18) !important;
  border-radius: 16px;
  box-shadow: none !important;
  margin-bottom: 16px;
}

::v-deep .ui-module-stepper .v-stepper__step,
::v-deep .ui-module-stepper .v-stepper__label,
::v-deep .ui-module-stepper .v-stepper__content {
  color: #e0e0e0 !important;
}

::v-deep .ui-module-stepper .v-stepper__step__step {
  background: rgba(var(--v-secondary-base-rgb), 0.18) !important;
  border-color: rgba(var(--v-secondary-base-rgb), 0.35) !important;
}

::v-deep .ui-module-stepper .v-stepper__step--active .v-stepper__step__step,
::v-deep .ui-module-stepper .v-stepper__step--complete .v-stepper__step__step {
  background: var(--v-secondary-base) !important;
  color: #08130f !important;
}

::v-deep .ui-module-stepper .v-stepper__label {
  font-weight: 600 !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #08130f !important;
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.28) !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(var(--v-secondary-base-rgb), 0.25) !important;
}

.text-caption {
  color: rgba(224, 224, 224, 0.72) !important;
}

.text-body-1 {
  color: #e0e0e0 !important;
}
</style>
